import './styles.scss';

import Button from '@/common/Button';
import HasPermission from '@/components/HasPermission';

type QuestionsHeaderProps = {
  onClick: () => void;
};

export const QuestionsHeader = ({ onClick }: QuestionsHeaderProps) => {
  return (
    <div className="QuestionsHeader">
      <div className="QuestionsHeader-TitleGroup">
        <h1 className="QuestionsHeader-Title text-primary">Training Items</h1>
        <p className="QuestionsHeader-Subtitle text-gray">
          Author the questions and evidence requirements that make up each category&apos;s checklist.
        </p>
      </div>
      <HasPermission name="allowEditTrainingSettings">
        <Button type="button" className="QuestionsHeader-AddButton" onClick={onClick}>
          <i className="sv sv-plus-square" aria-hidden="true" />
          Add Item
        </Button>
      </HasPermission>
    </div>
  );
};
